import formatStrDate from '@utils/format-str-date'
import _ from 'lodash'

const excerptMaxLength = 150

export const transform = (item) => {
  return {
    resourceId: item.id,
    title: item.title,
    content: item.body,
    excerpt: _.truncate(item.excerpt, { length: excerptMaxLength + 3 }),
    tags: item.tags?.map((tag) => tag.value) || [],
    departmentName: item.departmentName,
    resourceType: item.postType,
    isDownloadable: isDownloadable(item),
    assetType: item.assetType,
    assetFileName: item.assetFileName,
    assetFileExtension: getFileExtension(item),
    assetSize: item.size !== '0.00' ? item.size : '',
    assetUrl: item.assetUrl,
    downloadCount: item.downloads,
    views: item.views,
    createdAt: item.createdAt,
    updatedAt: item.updatedAt,
    revisedAt: item.revisedAt ? formatStrDate(item.revisedAt) : '',
    publishedAt: item.publishedAt ? formatStrDate(item.publishedAt) : '',
    categoryId: item.category ? item.category.id : '',
    categoryName: item.category ? item.category.value : '',
    subcategoryId: item.subcategory ? item.subcategory.id : '',
    subcategoryName: item.subcategory ? item.subcategory.value : '',
    isFavorite: item.isFavorite,
    favoritedAt: item.favoritedAt,
    sortMethod: getSortMethod(item),
    relatedResources: item.content,
  }
}

export const transformMany = (items) => {
  return items.map((item) => transform(item))
}

function getFileExtension({ assetFileName, assetType }) {
  if (assetType === 'video') {
    return ''
  }

  if (assetType === 'zip') {
    return 'zip'
  }

  if (!assetFileName) {
    return ''
  }

  return assetFileName.split('.').pop().toLowerCase()
}

function isDownloadable({ postType = '', isDownloadable = false }) {
  return isDownloadable && (postType === 'package' || postType === 'media')
}

function getSortMethod({ subcategory }) {
  if (subcategory?.value?.toUpperCase() === 'STATE COMPLIANCE') {
    return 'alphabetical'
  }

  return null
}
